import { queryOptions, useQuery } from '@tanstack/react-query';

import { workflowTemplatesApi } from '../api/workflows-api';

import { workflowKeys } from './workflow-keys';

export function workflowTemplatesQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: workflowKeys.list(storeId),
    queryFn: () => workflowTemplatesApi.list(storeId),
  });
}

export function useWorkflowTemplates(storeId: string, options: { enabled?: boolean } = {}) {
  return useQuery({ ...workflowTemplatesQueryOptions(storeId), enabled: options.enabled ?? true });
}

/**
 * Names only (`?summary=true`), readable with `orders.write`, for the order's switch dialog; the
 * full list needs `settings.read`.
 */
export function useWorkflowTemplateSummaries(storeId: string) {
  return useQuery({
    queryKey: [...workflowKeys.list(storeId), 'summary'] as const,
    queryFn: () => workflowTemplatesApi.summaries(storeId),
  });
}
